import { registerPlugin } from '@capacitor/core';
const capacitorPluginInstance = registerPlugin('MetaMapCapacitor', {});
const MetaMapCapacitor = {
    showMetaMapFlow: (options) => {
        const { metadata } = options;
        return capacitorPluginInstance.showMetaMapFlow(Object.assign(Object.assign({}, options), { metadata: Object.assign(Object.assign({}, metadata), { sdkType: "capacitor" }) }));
    },
    addListener: (eventName, listenerFunc) => {
        return capacitorPluginInstance.addListener(eventName, listenerFunc);
    },
    removeAllListeners: () => {
        return capacitorPluginInstance.removeAllListeners();
    }
};
export * from './definitions';
export { MetaMapCapacitor };
//# sourceMappingURL=index.js.map